import React from "react";
import { BsTwitter, BsLinkedin, BsInstagram, BsYoutube } from "react-icons/bs";
import Bootstrap from "./bootstrap";

function Header() {
  return (
    <section id="header">
      <Bootstrap />
      <div className="container">
        <header className="d-flex flex-wrap justify-content-center py-3 mb-4">
          <a
            href="/"
            className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none"
          >
            <span className="fs-4 text-white fw-bold">microstar</span>
          </a>

          <ul className="nav nav-pills">
            <a href="https://twitter.com/microstargg" aria-current="page">
              <li className="m-1 nav-item icon-square bg-body-secondary d-inline-flex align-items-center justify-content-center">
                <BsTwitter className="svg-color" />
              </li>
            </a>
            <a href="https://www.linkedin.com/in/ben-kyle/" aria-current="page">
              <li className="m-1 nav-item icon-square bg-body-secondary d-inline-flex align-items-center justify-content-center">
                <BsLinkedin className="svg-color" />
              </li>
            </a>
            <a href="https://www.instagram.com/microstargg/" aria-current="page">
              <li className="m-1 nav-item icon-square bg-body-secondary d-inline-flex align-items-center justify-content-center">
                <BsInstagram className="svg-color" />
              </li>
            </a>
            <a href="https://www.youtube.com/@microstar125" aria-current="page">
              <li className="m-1 nav-item icon-square bg-body-secondary d-inline-flex align-items-center justify-content-center">
                <BsYoutube className="svg-color" />
              </li>
            </a>
          </ul>
        </header>
      </div>
    </section>
  );
}

export default Header;
